class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', event => { if (event.code === 'Escape') this.close(); });
    this.addEventListener('click', event => { if (event.target.closest('#CartDrawer-Overlay')) this.close(); const removeMix = event.target.closest('[data-cp-remove-mix]'); if (removeMix) window.CandyPeakOwnedCart.removeMixBoxes(removeMix).catch(() => {}); });
    const link = document.getElementById('cart-icon-bubble');
    if (link) {
      link.setAttribute('role', 'button');
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', event => { event.preventDefault(); window.CandyPeakOwnedCart.open(link).catch(() => {}); });
      link.addEventListener('keydown', event => { if (event.code === 'Space') { event.preventDefault(); window.CandyPeakOwnedCart.open(link).catch(() => {}); } });
    }
  }
  open(trigger) {
    if (trigger) this.setActiveElement(trigger);
    this.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden', 'cp-owned-cart-open');
    requestAnimationFrame(() => this.restoreFocus());
    document.dispatchEvent(new CustomEvent('cp:cart:opened'));
  }
  restoreFocus(target) {
    if (!this.classList.contains('active')) return;
    const container = this.querySelector('.drawer__inner');
    if (container) trapFocus(container, target || this.querySelector('.drawer__close') || container);
  }
  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement?.isConnected ? this.activeElement : document.getElementById('cart-icon-bubble'));
    document.body.classList.remove('overflow-hidden', 'cp-owned-cart-open');
  }
  setActiveElement(element) { this.activeElement = element; }
  getSectionsToRender() { return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }]; }
  renderContents(response, trigger = this.activeElement, origin) { return window.CandyPeakOwnedCart.confirmAdd(response, trigger, origin).catch(() => {}); }
  getSectionInnerHTML(html, selector = '.shopify-section') { return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML || ''; }
}
if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  onCartUpdate() { window.CandyPeakOwnedCart?.refresh().catch(() => {}); }
  onChange(event) {
    if (!event.target.matches('.quantity__input')) return;
    this.updateQuantity(event.target.dataset.index, event.target.value);
  }
  updateQuantity(line, quantity) {
    const row = this.querySelector(`#CartDrawer-Item-${line}`);
    if (!row) return;
    window.CandyPeakOwnedCart.changeItem(row.dataset.lineKey, Number(quantity));
  }
  getSectionsToRender() { return [{ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' }, { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }]; }
}
if (!customElements.get('cart-drawer-items')) customElements.define('cart-drawer-items', CartDrawerItems);

(() => {
  if (window.CandyPeakOwnedCart) return;
  const base = window.Shopify?.routes?.root || '/';
  const depositRecoveryStorageKey = 'cp_drinkbox_deposit_recovery_v1';
  try {
    const saved = JSON.parse(window.sessionStorage?.getItem(depositRecoveryStorageKey) || 'null');
    if (!window.__cpDrinkboxDepositRecoveryPending && saved && typeof saved.boxId === 'string' && saved.boxId && ['deposit', 'bundle'].includes(saved.phase)) {
      window.__cpDrinkboxDepositRecoveryPending = saved;
    }
  } catch {}
  const reconcileDepositRecovery = cart => {
    const pending = window.__cpDrinkboxDepositRecoveryPending;
    if (!pending || !Array.isArray(cart?.items)) return;
    const lines = cart.items.filter(item => item.properties?._cpBoxId === pending.boxId);
    const deposits = lines.filter(item => item.properties?._cpLineType === 'drinkbox-deposit');
    const drinks = lines.filter(item => /^MIX-688782_JB9_[1-6]$/.test(String(item.properties?.['_easyBundle:OfferId'] || '')));
    if (lines.length !== 7 || deposits.length !== 1 || drinks.length !== 6 || drinks.some(item => Number(item.quantity) !== 1)) return;
    const offers = new Set(drinks.map(item => item.properties['_easyBundle:OfferId']));
    if (offers.size !== 6) return;
    const deposit = deposits[0];
    if (Number(deposit.quantity) !== 1 || Number(deposit.original_line_price ?? deposit.line_price) !== 150 || Number(deposit.final_line_price ?? deposit.line_price) !== 150) return;
    window.__cpDrinkboxDepositRecoveryPending = null;
    try { window.sessionStorage?.removeItem(depositRecoveryStorageKey); } catch {}
    document.dispatchEvent(new CustomEvent('cp:drinkbox-deposit-resolved', { detail: { source: 'owned-cart', boxId: pending.boxId } }));
  };
  let refreshing = null;
  let rerun = false;
  let mutation = null;
  let refreshTimer;
  let refreshFailed = false;
  const drawer = () => document.querySelector('cart-drawer.cp-owned-cart');
  const hasPendingQuantity = () => [...(drawer()?.querySelectorAll('.quantity__input') || [])].some(input =>
    !input.disabled && !input.closest('[data-cp-protected], [data-cp-cart-fee="true"]') &&
    Number(input.value) !== Number(input.getAttribute('value')));
  const checkoutUnavailable = () => {
    const root = drawer();
    return !root || mutation || refreshing || refreshFailed || window.__cpDrinkboxDepositRecoveryPending || hasPendingQuantity() ||
      root.classList.contains('is-empty') || root.hasAttribute('data-cp-cart-busy') ||
      root.hasAttribute('data-cp-cart-error');
  };
  document.addEventListener('click', event => {
    const button = event.target?.closest?.('#CartDrawer-Checkout');
    if (button && (button.disabled || checkoutUnavailable())) event.preventDefault();
  }, true);
  document.addEventListener('change', event => {
    if (!event.target?.matches?.('cart-drawer.cp-owned-cart .quantity__input')) return;
    const button = drawer()?.querySelector('#CartDrawer-Checkout');
    if (button && hasPendingQuantity()) { button.disabled = true; button.setAttribute('aria-disabled', 'true'); button.tabIndex = -1; }
  }, true);
  const errorText = error => typeof error?.description === 'string' ? error.description : typeof error?.message === 'string' ? error.message : window.cartStrings?.error || 'Cart error';
  let feedback = null;
  let feedbackTimer = null;
  let feedbackSequence = 0;
  const feedbackLabels = () => {
    const german = document.documentElement.lang.toLowerCase().startsWith('de');
    const fallback = german ? {
      added: 'Im Warenkorb', view: 'Warenkorb ansehen', close: 'Bestätigung schließen',
      updated: 'Dein Warenkorb wurde aktualisiert.', errorTitle: 'Warenkorb prüfen',
      error: 'Warenkorb konnte nicht aktualisiert werden. Bitte prüfe ihn erneut.'
    } : {
      added: 'In your cart', view: 'View cart', close: 'Close confirmation',
      updated: 'Your cart has been updated.', errorTitle: 'Check your cart',
      error: 'Your cart could not be updated. Please check it again.'
    };
    try {
      const source = document.querySelector('[data-cp-cart-feedback-labels]');
      const labels = source ? JSON.parse(source.textContent) : window.cpCartFeedbackStrings;
      if (labels && typeof labels === 'object') {
        Object.keys(fallback).forEach(key => { if (typeof labels[key] === 'string' && labels[key].trim()) fallback[key] = labels[key]; });
      }
    } catch {}
    return fallback;
  };
  const hideFeedback = () => {
    clearTimeout(feedbackTimer);
    if (feedback) feedback.hidden = true;
  };
  const restartFeedbackTimer = () => {
    clearTimeout(feedbackTimer);
    if (!feedback || feedback.hidden || feedback.matches(':hover') || feedback.contains(document.activeElement) || feedback.dataset.error === 'true') return;
    feedbackTimer = setTimeout(hideFeedback, 6000);
  };
  const makeFeedback = () => {
    if (feedback?.isConnected) return feedback;
    const root = document.createElement('aside');
    root.id = 'cp-owned-feedback'; root.className = 'cp-owned-feedback'; root.hidden = true;
    const media = document.createElement('img');
    media.className = 'cp-owned-feedback__image'; media.width = 48; media.height = 54; media.alt = ''; media.hidden = true;
    const copy = document.createElement('div');
    copy.className = 'cp-owned-feedback__copy'; copy.setAttribute('aria-live', 'polite'); copy.setAttribute('aria-atomic', 'true'); copy.setAttribute('role', 'status');
    const heading = document.createElement('strong'); heading.className = 'cp-owned-feedback__heading';
    const title = document.createElement('p'); title.className = 'cp-owned-feedback__title'; copy.append(heading, title);
    const view = document.createElement('button'); view.type = 'button'; view.className = 'cp-owned-feedback__view';
    view.addEventListener('click', () => {
      hideFeedback();
      window.CandyPeakOwnedCart.open(document.getElementById('cart-icon-bubble')).catch(() => {});
    });
    const close = document.createElement('button'); close.type = 'button'; close.className = 'cp-owned-feedback__close'; close.textContent = '×';
    close.addEventListener('click', () => { hideFeedback(); if (document.activeElement === close) document.getElementById('cart-icon-bubble')?.focus(); });
    root.addEventListener('mouseenter', () => clearTimeout(feedbackTimer));
    root.addEventListener('mouseleave', restartFeedbackTimer);
    root.addEventListener('focusin', () => clearTimeout(feedbackTimer));
    root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) queueMicrotask(restartFeedbackTimer); });
    root.addEventListener('keydown', event => { if (event.key === 'Escape') { hideFeedback(); document.getElementById('cart-icon-bubble')?.focus(); } });
    root.append(media, copy, view, close); document.body.append(root); feedback = root;
    return root;
  };
  const feedbackItem = (payload, trigger) => {
    const data = payload?.data && typeof payload.data === 'object' ? payload.data : payload;
    const variantID = trigger?.closest?.('form')?.querySelector('[name="id"]')?.value || trigger?.dataset?.variantId || trigger?.dataset?.id;
    let items = Array.isArray(data) ? data : Array.isArray(data?.items) ? data.items : Array.isArray(data?.products) ? data.products : data?.item ? [data.item] : data?.product ? [data.product] : data?.cart?.items || [data];
    items = items.filter(item => item && typeof item === 'object' && !['deposit', 'drinkbox-deposit'].includes(item.properties?._cpLineType) && String(item.properties?._cpDrinkboxDeposit) !== 'true' && !/(?:^|[-\s])(?:pfand|deposit)(?:$|[-\s])/i.test(`${item.handle || ''} ${item.product_title || item.title || ''}`));
    const matched = variantID && items.find(item => String(item.variant_id || item.id) === String(variantID));
    const isFullCart = typeof data?.item_count === 'number' || data?.cart;
    // A full-cart response without a matching trigger cannot identify the added product reliably.
    const item = matched || (isFullCart && items.length > 1 ? null : items[0]);
    if (!item) return {};
    const image = item.image?.url || item.image?.src || (typeof item.image === 'string' ? item.image : '') || item.featured_image?.url || item.featured_image?.src || (typeof item.featured_image === 'string' ? item.featured_image : '') || item.images?.[0]?.src || item.images?.[0]?.url || (typeof item.images?.[0] === 'string' ? item.images[0] : '');
    return { title: typeof item.product_title === 'string' ? item.product_title : typeof item.title === 'string' ? item.title : '', image };
  };
  // The old CandyPeak feedback used this same rocket character. Keep it tied to
  // confirmed additions instead of clicks: variant selection and failed requests
  // must never imply that something has reached the cart.
  const animatedAdditions = new WeakSet();
  const visibleRect = element => {
    const rect = element?.getBoundingClientRect?.();
    if (!rect || rect.width <= 0 || rect.height <= 0 || rect.bottom <= 0 ||
        rect.top >= window.innerHeight || rect.right <= 0 || rect.left >= window.innerWidth) return null;
    return rect;
  };
  const rocketOrigin = trigger => {
    const source = trigger || document.activeElement;
    const card = source?.closest?.('.card-wrapper,.cp-tiktok__card,.cpz__card,[data-mystery-card]');
    const rect = visibleRect(source) || visibleRect(card?.querySelector('img'));
    return rect ? { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 } : { x: window.innerWidth / 2, y: window.innerHeight * .65 };
  };
  const launchCartRocket = (payload, origin) => {
    const data = payload?.data && typeof payload.data === 'object' ? payload.data : payload;
    if (!origin || document.hidden ||
        window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ||
        !data || typeof data !== 'object' || data.errors || data.status >= 400 ||
        animatedAdditions.has(data)) return;
    const target = drawer()?.classList.contains('active')
      ? drawer().querySelector('.drawer__heading')
      : document.getElementById('cart-icon-bubble');
    const rect = visibleRect(target);
    if (!rect || typeof target.animate !== 'function') return;
    animatedAdditions.add(data);
    const size = 42;
    const startX = Math.max(size / 2, Math.min(window.innerWidth - size / 2, origin.x));
    const startY = Math.max(size / 2, Math.min(window.innerHeight - size / 2, origin.y));
    const deltaX = rect.left + rect.width / 2 - startX;
    const deltaY = rect.top + rect.height / 2 - startY;
    const rocket = document.createElement('span');
    rocket.className = 'cp-owned-cart-rocket';
    rocket.textContent = '🚀';
    rocket.setAttribute('aria-hidden', 'true');
    rocket.style.left = `${startX - size / 2}px`;
    rocket.style.top = `${startY - size / 2}px`;
    document.body.appendChild(rocket);
    const animation = rocket.animate([
      { transform: 'translate3d(0,8px,0) scale(.65) rotate(-18deg)', opacity: 0 },
      { offset: .10, transform: 'translate3d(0,-12px,0) scale(1) rotate(-14deg)', opacity: 1 },
      { offset: .45, transform: `translate3d(${deltaX * .28}px,${deltaY * .45 - 38}px,0) scale(.9) rotate(2deg)`, opacity: 1 },
      { offset: .82, transform: `translate3d(${deltaX * .88}px,${deltaY * .87 - 10}px,0) scale(.55) rotate(20deg)`, opacity: 1 },
      { transform: `translate3d(${deltaX}px,${deltaY}px,0) scale(.12) rotate(28deg)`, opacity: 0 }
    ], { duration: 1000, easing: 'cubic-bezier(.22,.55,.35,1)', fill: 'forwards' });
    animation.finished.then(() => {
      if (document.hidden ||
          window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches) return;
      const current = visibleRect(target);
      if (!current) return;
      const ring = document.createElement('span');
      ring.className = 'cp-owned-cart-impact';
      ring.setAttribute('aria-hidden', 'true');
      ring.style.left = `${current.left + current.width / 2 - size / 2}px`;
      ring.style.top = `${current.top + current.height / 2 - size / 2}px`;
      document.body.appendChild(ring);
      ring.animate([
        { transform: 'scale(.65)', opacity: .65 },
        { transform: 'scale(1.4)', opacity: 0 }
      ], { duration: 350, easing: 'ease-out', fill: 'forwards' }).finished
        .catch(() => {}).finally(() => ring.remove());
    }).catch(() => {}).finally(() => rocket.remove());
    // A suspended tab or interrupted animation must not leave decorative nodes.
    window.setTimeout(() => rocket.remove(), 1800);
  };
  const successfulAddFeedback = (result, trigger, origin, showConfirmation = true) => {
    if (showConfirmation) showFeedback(result, trigger);
    try { launchCartRocket(result, origin); } catch {}
  };
  const showFeedback = (payload, trigger, errorMessage) => {
    if (drawer()?.classList.contains('active')) { hideFeedback(); return; }
    const root = makeFeedback(); const labels = feedbackLabels(); const item = feedbackItem(payload, trigger);
    root.dataset.error = String(Boolean(errorMessage));
    const copy = root.querySelector('.cp-owned-feedback__copy');
    copy.setAttribute('role', errorMessage ? 'alert' : 'status'); copy.setAttribute('aria-live', errorMessage ? 'assertive' : 'polite');
    root.querySelector('.cp-owned-feedback__heading').textContent = errorMessage ? labels.errorTitle : labels.added;
    root.querySelector('.cp-owned-feedback__title').textContent = errorMessage || item.title || labels.updated;
    root.querySelector('.cp-owned-feedback__view').textContent = labels.view;
    root.querySelector('.cp-owned-feedback__close').setAttribute('aria-label', labels.close);
    const image = root.querySelector('img'); image.hidden = true; image.removeAttribute('src');
    if (!errorMessage && item.image) {
      try {
        const url = new URL(item.image, location.origin);
        if (url.protocol === 'https:' || url.protocol === 'http:') {
          image.onerror = () => { image.hidden = true; root.classList.add('cp-owned-feedback--no-image'); };
          image.src = url.href; image.hidden = false;
        }
      } catch {}
    }
    root.classList.toggle('cp-owned-feedback--no-image', image.hidden);
    root.hidden = false; restartFeedbackTimer();
  };
  const showError = error => {
    const target = document.getElementById('CartDrawer-CartErrors');
    if (target) { target.textContent = errorText(error); target.setAttribute('role', 'alert'); }
    if (!drawer()?.classList.contains('active')) showFeedback(null, null, typeof error?.description === 'string' ? error.description : feedbackLabels().error);
  };
  document.addEventListener('cp:cart:opened', hideFeedback);
  const getJSON = async (url, options) => {
    const response = await fetch(url, options);
    const data = await response.json();
    if (!response.ok || data.errors || data.status >= 400) throw Object.assign(new Error(typeof data.errors === 'string' ? data.errors : errorText(data)), data);
    return data;
  };
  const post = (path, data) => getJSON(base + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) });
  const readCart = () => getJSON(base + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
  const protectedItem = item => Boolean(/^MIX-688782_JB9_[1-6]$/.test(String(item?.properties?.['_easyBundle:OfferId'] || '')) || ['deposit', 'drinkbox-deposit'].includes(item?.properties?._cpLineType) || String(item?.properties?._cpDrinkboxDeposit) === 'true' || ['pfand', 'drinkbox-pfand'].includes(item?.handle) || item?.handle === 'fees' && item?.product_title === 'Pfand');
  const setBusy = busy => {
    const root = drawer(); if (!root) return;
    root.toggleAttribute('data-cp-cart-busy', busy);
    root.toggleAttribute('data-cp-cart-error', refreshFailed);
    root.toggleAttribute('data-cp-cart-deposit-error', Boolean(window.__cpDrinkboxDepositRecoveryPending));
    root.setAttribute('aria-busy', String(busy));
    root.querySelectorAll('.quantity__button,.quantity__input,cart-remove-button button,[data-cp-remove-mix],button.cp-owned-cart-recommendations__action').forEach(control => { control.disabled = busy || refreshFailed || control.hasAttribute('data-cp-needs-choice') || Boolean(control.closest('[data-cp-protected]')); });
    const checkout = root.querySelector('#CartDrawer-Checkout');
    if (checkout) {
      const unavailable = busy || refreshFailed || Boolean(window.__cpDrinkboxDepositRecoveryPending) || hasPendingQuantity() || root.classList.contains('is-empty');
      checkout.disabled = unavailable;
      checkout.toggleAttribute('disabled', unavailable);
      checkout.setAttribute('aria-disabled', String(unavailable));
      checkout.tabIndex = unavailable ? -1 : 0;
    }
  };
  // Refresh never opens the drawer; only an explicit open() action may do that.
  const refresh = () => {
    if (refreshing) { rerun = true; return refreshing; }
    refreshing = (async () => {
      do {
        rerun = false;
        const root = drawer(); if (!root) return;
        let cart = await readCart();
        const url = new URL(base, location.origin);
        url.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
        const sections = await getJSON(url.toString(), { cache: 'no-store' });
        const parsed = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html');
        const incoming = parsed.querySelector('#CartDrawer');
        const current = root.querySelector('#CartDrawer');
        if (!incoming || !current) throw new Error(window.cartStrings?.error || 'Cart error');
        try { cart = JSON.parse(incoming.querySelector('[data-cp-owned-cart-state]').textContent); } catch {}
        reconcileDepositRecovery(cart);
        const active = document.activeElement;
        const focusKey = active?.closest('[data-line-key]')?.dataset.lineKey;
        const focusName = active?.getAttribute('name');
        current.innerHTML = incoming.innerHTML;
        refreshFailed = false;
        if (feedback?.dataset.error === 'true') hideFeedback();
        root.classList.toggle('is-empty', !cart.item_count);
        const bubble = document.getElementById('cart-icon-bubble');
        const bubbleDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'] || '', 'text/html');
        const bubbleContent = bubbleDoc.querySelector('.shopify-section');
        if (bubble && bubbleContent) bubble.innerHTML = bubbleContent.innerHTML;
        if (root.contains(active) || focusKey) {
          const row = [...root.querySelectorAll('[data-line-key]')].find(node => node.dataset.lineKey === focusKey);
          const target = row ? [...row.querySelectorAll('[name]')].find(node => node.getAttribute('name') === focusName) : null;
          root.restoreFocus(target);
        } else if (root.classList.contains('active')) root.restoreFocus();
        document.dispatchEvent(new CustomEvent('cp:cart:updated', { detail: { cart } }));
        setBusy(Boolean(mutation));
      } while (rerun);
    })().catch(error => { refreshFailed = true; setBusy(Boolean(mutation)); showError(error); throw error; }).finally(() => { refreshing = null; });
    return refreshing;
  };
  const runMutation = (work, button, open) => {
    if (mutation) {
      if (button) button.disabled = true;
      return mutation.catch(() => {}).then(() => runMutation(work, button, open));
    }
    if (button) button.disabled = true;
    setBusy(true);
    mutation = (async () => {
      try {
        const result = await work();
        await refresh();
        return result;
      } catch (error) {
        try { await refresh(); } catch {}
        showError(error);
        throw error;
      }
      finally { setBusy(false); if (button?.isConnected) button.disabled = false; mutation = null; }
    })();
    return mutation;
  };
  const confirmAdd = async (result, trigger, capturedOrigin) => {
    const sequence = ++feedbackSequence;
    const origin = capturedOrigin || rocketOrigin(trigger);
    drawer()?.setActiveElement(trigger || document.activeElement);
    await refresh();
    successfulAddFeedback(result, trigger, origin, sequence === feedbackSequence);
    return result;
  };
  const addItem = (item, button) => {
    const origin = rocketOrigin(button);
    drawer()?.setActiveElement(button || document.activeElement);
    return runMutation(() => post('cart/add.js', { items: [item] }), button, false).then(result => {
      successfulAddFeedback(result, button, origin);
      return result;
    });
  };
  const changeItem = (key, quantity) => runMutation(async () => {
    if (!Number.isInteger(quantity) || quantity < 0) throw new Error(window.cartStrings?.error || 'Cart error');
    const cart = await readCart();
    const item = cart.items.find(line => line.key === key);
    if (!item || protectedItem(item)) return;
    return post('cart/change.js', { id: key, quantity });
  }, null, false).catch(() => {});
  const removeMixBoxes = button => runMutation(async () => {
    const cart = await readCart();
    const updates = {};
    cart.items.forEach(item => {
      const offer = String(item.properties?.['_easyBundle:OfferId'] || '');
      if (/^MIX-688782_JB9_[1-6]$/.test(offer) || item.properties?._cpLineType === 'drinkbox-deposit' || String(item.properties?._cpDrinkboxDeposit) === 'true') updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return;
    return post('cart/update.js', { updates });
  }, button, false);
  const open = async trigger => {
    ++feedbackSequence;
    hideFeedback();
    drawer()?.open(trigger || document.activeElement);
    setBusy(true);
    try { await refresh(); }
    finally { setBusy(Boolean(mutation)); }
  };
  window.CandyPeakOwnedCart = { addItem, confirmAdd, captureAddOrigin: rocketOrigin, changeItem, removeMixBoxes, refresh, open, close: () => drawer()?.close() };
  const schedule = () => { clearTimeout(refreshTimer); refreshTimer = setTimeout(() => refresh().catch(() => {}), 160); };
  ['cart:refresh', 'cart:updated', 'cart:change', 'fg-cart:auto-updated', 'fg-gifts:updated', 'fg-gifts:added'].forEach(name => { document.addEventListener(name, schedule); window.addEventListener(name, schedule); });
  document.addEventListener('fg-cart:end-process', () => {
    setBusy(true);
    refresh().catch(() => {});
  });
  document.addEventListener('cp:drinkbox-deposit-pending', () => {
    setBusy(Boolean(mutation) || Boolean(refreshing));
    showError(new Error(window.__cpDrinkboxDepositRecoveryPending?.message || feedbackLabels().error));
  });
  document.addEventListener('cp:drinkbox-deposit-resolved', event => {
    setBusy(Boolean(mutation) || Boolean(refreshing));
    if (event.detail?.source !== 'owned-cart') refresh().catch(() => {});
  });
  if (window.__cpDrinkboxDepositRecoveryPending) setBusy(false);
})();
